import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SettingsStore {
  muted: boolean;
  reducedMotion: boolean;
  showLifeDashboard: boolean;
  showRepDashboard: boolean;
  themeId: string;
  playerHandle: string;        // displayed as @handle on Y; default 'you'
  toggleMute: () => void;
  setReducedMotion: (v: boolean) => void;
  setShowLifeDashboard: (v: boolean) => void;
  setShowRepDashboard: (v: boolean) => void;
  setTheme: (id: string) => void;
  setPlayerHandle: (h: string) => void;
}

export const useSettings = create<SettingsStore>()(
  immer((set) => ({
    muted: true, // mobile default; one-tap to enable
    reducedMotion: false,
    showLifeDashboard: false,
    showRepDashboard: false,
    themeId: 'bloomberg-amber',
    playerHandle: 'you',
    toggleMute: () => set((s) => { s.muted = !s.muted; }),
    setReducedMotion: (v) => set((s) => { s.reducedMotion = v; }),
    setShowLifeDashboard: (v) => set((s) => { s.showLifeDashboard = v; }),
    setShowRepDashboard: (v) => set((s) => { s.showRepDashboard = v; }),
    setTheme: (id) => set((s) => { s.themeId = id; }),
    setPlayerHandle: (h) => set((s) => {
      // Sanitize: lowercase, alphanum + underscore, max 20 chars, default 'you' if empty
      const cleaned = h.trim().toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 20);
      s.playerHandle = cleaned || 'you';
    }),
  })),
);
